// Maps a client-portal route to its most relevant Help article slug.
// Used by the contextual "?" in the header to deep-link the right article.

const ROUTE_TO_SLUG = {
  '/client/dashboard': 'your-dashboard',
  '/client/shop': 'shopping-by-delivery-date',
  '/client/checkout': 'checkout-lead-times',
  '/client/orders': 'managing-orders',
  '/client/invoices': 'viewing-invoices',
  '/client/payment-methods': 'payment-methods',
  '/client/messages': 'messages-and-support',
  '/client/reports': 'your-dashboard',
  '/client/profile': 'profile-and-locations',
  '/client/team': 'team-and-roles',
};

export function helpArticleForPath(pathname) {
  if (!pathname) return null;
  // exact match first
  if (ROUTE_TO_SLUG[pathname]) return ROUTE_TO_SLUG[pathname];
  // prefix match (e.g. /client/orders/123)
  const key = Object.keys(ROUTE_TO_SLUG).find((p) => pathname.startsWith(p));
  return key ? ROUTE_TO_SLUG[key] : null;
}
